import React, { useEffect } from "react";

const TOAST_CONFIG = {
  success: {
    border: "border-emerald-200 dark:border-emerald-700/50",
    accent: "border-l-emerald-500 dark:border-l-emerald-400",
    icon: "fa-check",
    iconBg: "bg-emerald-100 dark:bg-emerald-900/40",
    iconColor: "text-emerald-600 dark:text-emerald-400",
    text: "text-emerald-900 dark:text-emerald-100",
  },
  error: {
    border: "border-red-200 dark:border-red-700/50",
    accent: "border-l-red-500 dark:border-l-red-400",
    icon: "fa-exclamation-circle",
    iconBg: "bg-red-100 dark:bg-red-900/40",
    iconColor: "text-red-600 dark:text-red-400",
    text: "text-red-900 dark:text-red-100",
  },
  warning: {
    border: "border-amber-200 dark:border-amber-700/50",
    accent: "border-l-amber-500 dark:border-l-amber-400",
    icon: "fa-exclamation-triangle",
    iconBg: "bg-amber-100 dark:bg-amber-900/40",
    iconColor: "text-amber-600 dark:text-amber-400",
    text: "text-amber-900 dark:text-amber-100",
  },
  info: {
    border: "border-blue-200 dark:border-blue-700/50",
    accent: "border-l-blue-500 dark:border-l-blue-400",
    icon: "fa-info-circle",
    iconBg: "bg-blue-100 dark:bg-blue-900/40",
    iconColor: "text-blue-600 dark:text-blue-400",
    text: "text-blue-900 dark:text-blue-100",
  },
};

const Toast = ({
  message,
  type = "info",
  isVisible,
  onClose,
  duration = 5000,
}) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const config = TOAST_CONFIG[type] || TOAST_CONFIG.info;

  return (
    <div className="fixed top-4 right-4 z-[200] pointer-events-auto">
      <div
        className={`
          flex items-center gap-3 pl-4 pr-3 py-3 
          bg-white dark:bg-slate-800 
          rounded-xl shadow-lg 
          border border-l-4 ${config.border} ${config.accent}
          transition-all duration-300
          animate-slide-in-right
          min-w-[260px] max-w-sm
        `}
      >
        <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center ${config.iconBg}`}>
          <i className={`fas ${config.icon} text-xs ${config.iconColor}`}></i>
        </div>
        <span className={`text-sm font-medium flex-1 leading-snug ${config.text}`}>
          {message}
        </span>
        <button
          onClick={onClose}
          className="flex-shrink-0 ml-1 w-6 h-6 flex items-center justify-center rounded-md text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
        >
          <i className="fas fa-times text-[10px]"></i>
        </button>
      </div>
    </div>
  );
};

export default Toast;
